import { POIGalleryPrivateSticky } from './poi-gallery-private-sticky';

export default POIGalleryPrivateSticky;
